'use strict';

import SimpleBar from 'simplebar';

import { anchor } from './module/_anchor';
import { carousel } from './module/_carousel';
import { hover } from './module/_hover';
import { inview } from './module/_inview';
import { modal } from './module/_modal';
import { nav } from './module/_nav';
import { button } from './module/_button';

const main = (() => {
    /**
     * loaded
     */
    const loaded = () => {
        $('body').addClass('is-loaded');

        if(location.hash) {

            anchor.moveTo(null, location.hash, 0, () => {
                inview.init();
            });
        }
        else {
            inview.init();
        }
    };

    /**
     * scrolled
     */
    const scrolled = () => {
        if($(window).scrollTop() >= $(window).outerHeight() / 10) {
            $('body').addClass('is-scrolled');
        }
        else {
            $('body').removeClass('is-scrolled');
        }
    };

    /**
     * resized
     */
    const resized = () => {
        setStyleVarVW();
        setStyleVarVH();
    };

    /**
     * setStyleVarVH
     */
    const setStyleVarVH = () => {
        let vh = $(window).innerHeight() * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    };

    /**
     * setStyleVarVW
     */
    const setStyleVarVW = () => {
        let vw = $(window).innerWidth() * 0.01;
        document.documentElement.style.setProperty('--vw', vw + 'px');
    };

    /**
     * init
     */
    const init = () => {
        scrolled();
        resized();

        anchor.init();
        carousel.init();
        hover.init();
        modal.init();
        nav.init();
        button.init();

        if($('.js-scrollbar').length > 0) {
            new SimpleBar(document.querySelector('.js-scrollbar'));
        }

        $('a, button').not('.fb-xfbml-parse-ignore').addClass('js-hover');

        $('a').not('[href="https://agri.ja-group.jp/"]').each((index, element) => {
            const url = location.protocol + '//' + location.host;
            const href = $(element).attr('href');

            // 外部リンクはtarget="_blank"に
            if(!href.startsWith(url) && !href.startsWith('/') && !href.startsWith('.') && !href.startsWith('#')) {
                $(element).attr('target', '_blank').attr('rel', 'noopener noreferrer');
            }

            // 拡張子が該当する場合はtarget="_blank"に
            if(/\.(xlsx?|docx?|pptx?|pdf|jpe?g|png|gif|svg)/.test(href.toLowerCase())) {
                $(element).attr('target', '_blank').attr('rel', 'noopener noreferrer');
            }
        });
    };

    // public
    return {
        init: init,
        loaded: loaded,
        scrolled: scrolled,
        resized: resized
    };
})();

$(() => {
    main.init();
});

$(window).on('load', () => {
    main.loaded();
});

$(window).on('scroll', () => {
    main.scrolled();
});

$(window).on('resize', () => {
    setTimeout(() => {
        main.resized();
    }, 100);
});
